<form class="vc-note-form" (ngSubmit)="this.execute()">
  <div class="vc-note-form__grid">
    <div class="vc-note-form__field vc-note-form__field--calendar">
      <label class="vc-note-form__label vc-note-form__label--required">
        {{ "COMMON.CALENDAR" | translate }}
      </label>
      <app-selector-calendar
        [onSelect]="this.handleCalendarChange"
      ></app-selector-calendar>
    </div>

    <div class="vc-note-form__field vc-note-form__field--title">
      <label class="vc-note-form__label vc-note-form__label--required" for="noteTitle">
        {{ "CALENDAR.NOTES.TITLE" | translate }}
      </label>
      <input
        pInputText
        name="noteTitle"
        id="noteTitle"
        [(ngModel)]="this.payload.title"
        pSize="small"
        fluid
      />
      <small *ngIf="this.errors.title" class="vc-note-form__error">
        {{ this.errors.title | translate }}
      </small>
    </div>

    <div class="vc-note-form__field vc-note-form__field--description">
      <label class="vc-note-form__label" for="noteDescription">
        {{ "CALENDAR.NOTES.DESCRIPTION" | translate }}
      </label>
      <textarea
        name="noteDescription"
        id="noteDescription"
        pInputTextarea
        [(ngModel)]="this.payload.description"
        [autoResize]="true"
        rows="2"
      ></textarea>
    </div>

    <div class="vc-note-form__field vc-note-form__field--date">
      <label class="vc-note-form__label vc-note-form__label--required" for="noteDate">
        {{ "CALENDAR.NOTES.DATE" | translate }}
      </label>
      <p-datepicker
        *ngIf="this.mode == 'create'"
        name="noteDate"
        [locale]="{ firstDayOfWeek: 1 }"
        id="noteDate"
        [dateFormat]="'dd/mm/yy'"
        [selectionMode]="'multiple'"
        [panelStyleClass]="'vc-note-datepicker-panel'"
        [(ngModel)]="this.payload.dates"
        appendTo="body"
        size="small"
      ></p-datepicker>
      <p-datepicker
        *ngIf="this.mode == 'edit'"
        name="noteDate"
        [locale]="{ firstDayOfWeek: 1 }"
        id="noteDateEdit"
        [dateFormat]="'dd/mm/yy'"
        [panelStyleClass]="'vc-note-datepicker-panel'"
        [(ngModel)]="this.payload.date"
        appendTo="body"
        size="small"
      ></p-datepicker>
      <small class="vc-note-form__hint" *ngIf="this.mode == 'create'">
        Puedes seleccionar múltiples fechas
      </small>
      <small *ngIf="this.errors.date" class="vc-note-form__error">
        {{ this.errors.date | translate }}
      </small>
    </div>

    <div class="vc-note-form__field vc-note-form__field--hours-toggle">
      <p-checkbox
        name="includeHours"
        [binary]="true"
        [(ngModel)]="this.includeHours"
        inputId="includeHours"
      ></p-checkbox>
      <label class="vc-note-form__label" for="includeHours">
        {{ "CALENDAR.NOTES.HOURS.INCLUDES" | translate }}
      </label>
    </div>

    <div class="vc-note-form__hours" *ngIf="this.includeHours">
      <div class="vc-note-form__field">
        <label class="vc-note-form__label vc-note-form__label--required" for="noteStart">
          {{ "CALENDAR.NOTES.HOURS.START" | translate }}
        </label>
        <p-datepicker
          name="noteStart"
          id="noteStart"
          [(ngModel)]="this.payload.start"
          [showTime]="true"
          [timeOnly]="true"
          [panelStyleClass]="'vc-note-datepicker-panel'"
          appendTo="body"
          size="small"
        ></p-datepicker>
        <small *ngIf="this.errors.start" class="vc-note-form__error">
          {{ this.errors.start | translate }}
        </small>
      </div>

      <div class="vc-note-form__field">
        <label class="vc-note-form__label vc-note-form__label--required" for="noteEnd">
          {{ "CALENDAR.NOTES.HOURS.END" | translate }}
        </label>
        <p-datepicker
          name="noteEnd"
          id="noteEnd"
          [(ngModel)]="this.payload.end"
          [showTime]="true"
          [timeOnly]="true"
          [panelStyleClass]="'vc-note-datepicker-panel'"
          appendTo="body"
          size="small"
        ></p-datepicker>
        <small *ngIf="this.errors.end" class="vc-note-form__error">
          {{ this.errors.end | translate }}
        </small>
      </div>
    </div>
  </div>

  <div class="vc-note-form__actions">
    <app-delete-button-calendar-note
      *ngIf="this.mode == 'edit' && this.hasPermission('CALENDAR_NOTES.DELETE')"
      [payload]="this.payload"
      [onDelete]="this.onUpdate"
    ></app-delete-button-calendar-note>

    <button
      *ngIf="this.checkPermissions()"
      type="submit"
      class="vc-note-form__submit-btn"
    >
      <i class="pi pi-check"></i>
      {{ "COMMON.SAVE" | translate }}
    </button>
  </div>
</form>
